<panel [panelInput]="panelConfig" (close)="onClose()">
    <ng-container panel-body>
        <div class="heightCalc-9 overflow-auto">
            <p class='text-secondary mb-3'>{{ 'pb_assign_approvers_info' | translate }}</p>
            <grid [data]="gridData" [columns]="columnDefs" [gridConfigItems]="gridConfigItems"
                 (onCellClick)="fnOnGridCellClick($event)"
                (onCheckAll)="fnOnGridCheckAll($event)" ></grid>
                <!-- [filterLabel]="filterByLabel" (searchTextChanged)="onSearchChanged($event)"
                >
            </grid> -->
        </div>
    </ng-container>
    <ng-container panel-footer>
        <ds-button [buttonInput]="saveButtonConfig" (btnClick)="onSaveBtnClicked()">
        </ds-button>
    </ng-container>
</panel>